import type { DateRange } from '@mgrvtechgroup/admin-ds';

function startOfDay(base: Date): Date {
  return new Date(base.getFullYear(), base.getMonth(), base.getDate());
}

function nextDay(base: Date): Date {
  return new Date(base.getFullYear(), base.getMonth(), base.getDate() + 1);
}

/**
 * 날짜 범위 선택값 → 서버로 보낼 시간대 포함 ISO 한 쌍.
 * 종료는 배타 경계(마지막 날의 다음 날 0시)라 마지막 날 전체가 범위에 든다. to가 없으면 하루짜리다.
 */
export function rangeToIso(range: DateRange): { start: string; end: string } | null {
  if (!range.from || !Number.isFinite(range.from.getTime())) return null;
  const last = range.to && Number.isFinite(range.to.getTime()) ? range.to : range.from;
  const first = startOfDay(range.from);
  const end = nextDay(last < range.from ? range.from : last);
  return { start: first.toISOString(), end: end.toISOString() };
}

/** 서버 ISO 한 쌍 → 날짜 범위. 종료가 정확히 0시면 그 전날이 마지막 날이다. */
export function isoToRange(start: string | null, end: string | null): DateRange | undefined {
  if (!start || !end) return undefined;
  const from = new Date(start);
  const endAt = new Date(end);
  if (!Number.isFinite(from.getTime()) || !Number.isFinite(endAt.getTime())) return undefined;
  const endDay = startOfDay(endAt);
  const lastDay =
    endDay.getTime() === endAt.getTime()
      ? new Date(endDay.getFullYear(), endDay.getMonth(), endDay.getDate() - 1)
      : endDay;
  const first = startOfDay(from);
  return { from: first, to: lastDay < first ? first : startOfDay(lastDay) };
}
